import { motion } from "framer-motion";
import { Download, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { mitglied, site } from "@/data/content";

const Mitglied = () => (
  <section id="mitglied" className="grain relative bg-fw-red py-28 md:py-40 text-white overflow-hidden" data-testid="mitglied-section">
    <div className="pointer-events-none absolute -right-20 -top-20 h-96 w-96 rounded-full bg-white/5 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <span className="font-technical uppercase tracking-[0.3em] text-fw-gold text-sm">{mitglied.kicker}</span>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-4 font-technical font-black uppercase leading-[0.85] text-6xl md:text-8xl lg:text-9xl">
          {mitglied.title}
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 max-w-2xl font-body text-lg md:text-xl text-white/85">{mitglied.text}</p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href={site.mitgliedUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mitglied-more-link"
            className="inline-flex items-center gap-2 border-b border-white/60 pb-1 font-technical uppercase tracking-widest text-white/90 hover:text-fw-gold"
          >
            {mitglied.primaryLabel} <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Mitglied;
